import moment from "moment";
import * as actionType from "../ActionTypes";
import * as mutationType from "../MutationType";
import api from "../../config/api";
const state = {
    analytics: {}
};
const getters = {
    analytics: (state) => state.analytics
};

const actions = {
    [actionType.USER_GET_ANALYTICS_KEYWORD]: async function ({ commit }) {
        return new Promise((resolve, reject) => {
            api.get('/user/analytics/keywords').then(result => {
                if(result.data.data) {
                    commit(mutationType.USER_SET_ANALYTICS, result.data.data)
                }
                resolve(result)
            })
            .catch(error => reject(error));
        });
    },
    [actionType.USER_GET_ANALYTICS_LISTING]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.get('/user/analytics/listings', {
                params: {
                    filter: params.type
                }
            }).then(result => {
                if(result.data.data) {
                    commit(mutationType.USER_SET_ANALYTICS, result.data.data)
                }
                resolve(result)
            })
            .catch(error => reject(error));
        });
    }
};

const mutations = {
    [mutationType.USER_SET_ANALYTICS]: function (state, data) {
        if(data.label_type) {
            switch(data.label_type) {
                case "HOUR":
                    data.labels = data.labels.map(item => moment().hour(item).minute(0).locale("th").format('HH:mm'));
                    break;
                case "DATE":
                    data.labels = data.labels.map(item => moment(new Date(item)).locale("th").format('DD/MM/YYYY'));
                    break;
                case "WEEK":
                    data.labels = data.labels.map(item =>  "Week " + moment().weekYear(item).format('WW'));
                    break;
                default:
                    data.labels = data.labels.map((item, index) =>  moment().month(index).locale("en").format('MMMM'));
            }
        }
        state.analytics = data;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}